import { Box, Typography } from "@mui/material";
import { memo } from "react";

import type { StatusBadgeProps } from "./StatusBadge.types";
import * as styles from "./StatusBadge.styles";

export type { StatusBadgeProps } from "./StatusBadge.types";

export const StatusBadge = memo(function StatusBadge({
  label,
  color = "error",
  size = "md",
}: StatusBadgeProps) {
  return (
    <Box component="span" sx={styles.root(color, size)}>
      <Typography component="span" variant="inherit" fontWeight="inherit" fontSize="inherit">
        {label}
      </Typography>
    </Box>
  );
});
